export default {
    data: () => ({
        translations: {
            userProfile: {
                el: "Στοιχεία Χρήστη",
                en: "User Details",
                it: "Dettagli Utente"
            },
            userMobile: {
                el: "Κινητό",
                en: "User Mobile",
                it: "Cellulare Utente"
            },
            smsCount: {
                el: "Σύνολο SMS",
                en: "SMS Count",
                it: "Conteggio SMS"
            },
            TOS: {
                el: "TOS",
                en: "TOS",
                it: "TOS"
            }
        }
    })
};
